import React from 'react';
import PropTypes from 'prop-types';
import pallet from 'constants/colors';
import { FontIcon } from 'material-ui';

const styles = {
  container: {
    margin: '6px 12px',
    height: 48,
    flex: '1 0 auto',
    display: 'flex',
  },
  button: {
    outline: 'none',
    border: 'none',
    fontWeight: 500,
    height: '100%',
    width: '100%',
    paddingLeft: 24,
    paddingRight: 24,
    fontSize: 16,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    marginRight: 4,
    color: 'inherit',
  },
  default: {
    textDecoration: 'none',
    borderRadius: 4,
    backgroundColor: pallet.mainButton,
    color: 'white',
  },
  flat: {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
    color: pallet.titleColor,
  },
  disabled: {
    cursor: 'auto',
    opacity: 0.2,
  },
};

const KButton = ({
  onClick,
  label,
  flat,
  containerStyle,
  buttonStyle,
  iconName,
  disabled,
  ...rest
}) => {
  const icon = (
    <FontIcon style={styles.icon} className="material-icons">{iconName}</FontIcon>
  );

  let button = (
    <button {...rest} disabled={disabled} style={{ ...styles.button, ...styles.default, ...buttonStyle }} onClick={onClick}>
      {iconName && icon}{label}
    </button>
  );
  if (disabled) {
    button = (
      <button {...rest} disabled={disabled} style={{ ...styles.button, ...styles.disabled, ...buttonStyle }} onClick={onClick}>
        {iconName && icon}{label}
      </button>
    );
  } else if (flat) {
    button = (
      <button {...rest} disabled={disabled} style={{ ...styles.button, ...styles.flat, ...buttonStyle }} onClick={onClick}>
        {iconName && icon}{label}
      </button>
    );
  }

  return (
    <div style={{ ...styles.container, ...containerStyle }}>
      {button}
    </div>
  );
};

KButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
  iconName: PropTypes.string,
  flat: PropTypes.bool,
  disabled: PropTypes.bool,
  buttonStyle: PropTypes.object,
  containerStyle: PropTypes.object,
};

export default KButton;



// WEBPACK FOOTER //
// ./src/components/KJRN/KButton.js